import { render, staticRenderFns } from "./BannerContato.vue?vue&type=template&id=23eb62e2&scoped=true&"
import script from "./BannerContato.vue?vue&type=script&lang=js&"
export * from "./BannerContato.vue?vue&type=script&lang=js&"
import style0 from "./BannerContato.vue?vue&type=style&index=0&id=23eb62e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb62e2",
  null
  
)

export default component.exports